import { render, staticRenderFns } from "./instFotoAdd.vue?vue&type=template&id=06257e22&scoped=true"
import script from "./instFotoAdd.vue?vue&type=script&lang=js"
export * from "./instFotoAdd.vue?vue&type=script&lang=js"
import style0 from "./instFotoAdd.vue?vue&type=style&index=0&id=06257e22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06257e22",
  null
  
)

export default component.exports